import { lazy } from "react";
import { RouteObject } from "react-router-dom";

import IntelligentCreation from "@/pages/intelligent-creation";

import { RouterGuard } from "../guard";
const AIPodcast = lazy(() => import("@/pages/ai-podcast"));

export const intelligentCreation: RouteObject = {
  path: "/intelligent-creation",
  element: <RouterGuard element={<IntelligentCreation />} />,
  children: [
    {
      index: true,
      element: <RouterGuard element={<IntelligentCreation />} />,
    },
    {
      path: "/intelligent-creation/ai-podcast",
      element: <RouterGuard element={<AIPodcast />} />,
    },
  ],
};
